import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ResearchPage from "@/pages/ResearchPage";
import B2BPage from "@/pages/B2BPage";
import ContactPage from "@/pages/ContactPage";
import HealthNotesPage from "@/pages/HealthNotesPage";
import HealthNoteDetailPage from "@/pages/HealthNoteDetailPage";
import FnacServicePage from "@/pages/FnacServicePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import RouteAnalytics from "@/lib/RouteAnalytics";
import FloatingReviewCTA from "@/components/FloatingReviewCTA";
import { Toaster } from "@/components/ui/sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Wrapper that hides the public Navbar/Footer on admin routes
const ShellRoutes = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/fnac-test-gwalior" element={<FnacServicePage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/b2b" element={<B2BPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<ContactPage />} />
          <Route path="/bookings" element={<ContactPage />} />
          <Route path="/health-notes" element={<HealthNotesPage />} />
          <Route path="/health-notes/:slug" element={<HealthNoteDetailPage />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingReviewCTA />}
    </>
  );
};

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <RouteAnalytics />
        <ShellRoutes />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
